import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigDataService } from '../../services/config-data.service';
import { StringUtilService } from '@core/services/string-util.service';
import { Config } from '../../models/config.model';

@Component({
  selector: 'app-config-editor',
  templateUrl: './config-editor.component.html',
  styleUrls: ['./config-editor.component.scss']
})
export class ConfigEditorComponent implements OnInit {

  private _data: Config;
  private consumerKey: string;
  public configKey: string;

  @ViewChild("configContent", { static: false }) configContent: any;
  @ViewChild("extension", { static: false }) extensionField: any;
  @ViewChild("configName", { static: false }) configNameField: any;

  public set data(data: Config) {
    // Sort history in reverse chronological order
    if (data.Archived) {
      data.Archived.sort((a, b) => {
        return a.Metadata.Timestamp < b.Metadata.Timestamp ? 1 : -1;
      });
    }

    this._data = data;
  }

  public get data() {
    return this._data;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public configDataService: ConfigDataService,
    public stringUtil: StringUtilService
  ) {
    this.route.params.subscribe((params) => {
      this.consumerKey = this.stringUtil.decode(params['consumerKey']);
      this.configKey = this.stringUtil.decode(params['configKey']);
      if (this.configKey != this.configDataService.RESERVED_NEW_CONFIG_KEY) {
        this.configDataService.getConfig({ consumerKey: this.consumerKey, configKey: this.configKey })
          .subscribe((config) => {
            this.data = config;
          });
      }
    });
  }

  ngOnInit(): void { }

  postConfig() {
    let params;
    if (this.configKey == this.configDataService.RESERVED_NEW_CONFIG_KEY) {
      params = {
        consumerKey: this.consumerKey,
        configKey: this.configNameField.nativeElement.value,
        extension: this.extensionField.nativeElement.value
      };
    } else {
      params = {
        consumerKey: this.consumerKey,
        configKey: this.configKey,
        extension: this.data.Metadata.Extension
      };
    }

    this.configDataService.postConfig(
      params,
      this.configContent.nativeElement.value
    ).subscribe((config) => {
      if (this.configKey == this.configDataService.RESERVED_NEW_CONFIG_KEY) {
        this.router.navigate(['config-manager', this.consumerKey, `${params.configKey}`]);
      } else {
        this.data = config;
      }
    });
  }
}
